import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bd1768e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade modal-lg",
  id: "emailCustomization",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "emailCustomization",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Available variables:"),
  /*#__PURE__*/_createElementVNode("i", null, " clientName, projectName, processName, workspaceName, actionUrl")
], -1))
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "form-label"
}, "Subject", -1))
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "headline",
  class: "form-label"
}, "Headline", -1))
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "body",
  class: "form-label"
}, "Body text", -1))
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "headline",
  class: "form-label"
}, "Button Text", -1))
const _hoisted_30 = { class: "modal-footer justify-content-between" }
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WYSIWYGEmailEditor = _resolveComponent("WYSIWYGEmailEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.emailTypeName) + ": " + _toDisplayString(_ctx.processName), 1),
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createTextVNode(" loading... "),
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _hoisted_19
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "subject",
                  placeholder: "A new Process has just created - {{projectName}} : {{workspaceName}}",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subject) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "headline",
                  placeholder: "A new Process has just created",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.headline) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.headline]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_WYSIWYGEmailEditor, {
                  content: _ctx.body,
                  "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.body) = $event))
                }, null, 8, ["content"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "buttonText",
                  placeholder: "View Process",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.buttonText) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.buttonText]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-dark",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                }, " Reset "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary float-end",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                  disabled: !_ctx.buttonText || !_ctx.body || !_ctx.headline || !_ctx.subject || _ctx.submitted
                }, _toDisplayString(_ctx.submitted ? "Saving" : "Save"), 9, _hoisted_31)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}